const viewHandler = (entries) => {
  for (const entry of entries) {
    entry.target.classList.toggle("is-in-view", entry.isIntersecting);
    entry.target.classList.toggle("is-not-in-view", !entry.isIntersecting);
  }
};
const viewOptions = {
  root: null,
  rootMargin: "-20% 0px",
  threshold: 0.25,
};
export const observer = new IntersectionObserver(viewHandler, viewOptions);

/**
 * Handle determination of whether the user has scrolled
 */
const scrollHandler = (entries) => {
  for (const entry of entries) {
    document.body.classList.toggle("has-scrolled", !entry.isIntersecting);
  }
};
const scrollOptions = {
  root: null,
  rootMargin: "0px 0px",
  threshold: 0,
};
const scrollElement = document.getElementById("scroll-indicator");
const scrollObserver = new IntersectionObserver(scrollHandler, scrollOptions);
if (scrollElement) {
  scrollObserver.observe(scrollElement);
}
